import styled from '@emotion/styled'
import bp from '@bbl-digital/snorre/lib/globals/styles/breakpoints'

export const MobileCheckboxWrapper = styled.div`
border-bottom: 1px solid #e6e6e6;
border-top: 1px solid #e6e6e6;
`

export const MobileCheckbox = styled.div`
  display: flex;
  gap: 10px;
  padding: 0.5em 0;
`

export const InfoButtonWrapper = styled.div`
  margin-bottom: 5px;
  margin-left: -5px;

  @media screen and (max-width: ${bp.small}) {
    margin-bottom: -5px;
	margin-left: -5px;
  }
`

export const CheckboxWrapper = styled.div`
  margin-bottom: 20px;
`
